import { GLOBAL_ENABLE_DEBUGING } from "../lib/types";

export const injectTestingAction = action => dispatch => {
  dispatch(action);
};

export const enableDebuging = () => dispatch => {
  dispatch({
    type: GLOBAL_ENABLE_DEBUGING
  });
};



// WEBPACK FOOTER //
// ./src/actions/layout-actions.js